export default [
    {
        path: '/teaching-calendars',
        name: 'teaching-calendar',
        meta: { requiresAuth: true },
        component: () => import('@/pages/teaching-calendar/index.vue')
    }
]
